'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ROW_HEIGHT = 24;

var NitroTextArea = function (_Component) {
  _inherits(NitroTextArea, _Component);

  function NitroTextArea(props) {
    _classCallCheck(this, NitroTextArea);

    var _this = _possibleConstructorReturn(this, (NitroTextArea.__proto__ || Object.getPrototypeOf(NitroTextArea)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      height: props.rows * ROW_HEIGHT
    };

    _this.handleResize = (0, _throttle2.default)(_this.handleResize, 200);
    return _this;
  }

  _createClass(NitroTextArea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.syncHeightWithShadow();

      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value || nextProps.rowsMax !== this.props.rowsMax) {
        this.syncHeightWithShadow(nextProps.value, null, nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'getInputNode',
    value: function getInputNode() {
      return this.input;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.getInputNode().value = value;
      this.syncHeightWithShadow(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onChange = _props.onChange,
          rows = _props.rows,
          other = _objectWithoutProperties(_props, ['onChange', 'rows']);

      return _react2.default.createElement(
        _styles.StyledTextArea,
        null,
        _react2.default.createElement(_styles.StyledTextAreaShadow, {
          innerRef: function innerRef(element) {
            _this2.shadow = element;
          },
          tabIndex: '-1',
          rows: this.props.rows,
          defaultValue: this.props.defaultValue,
          readOnly: true,
          value: this.props.value
        }),
        _react2.default.createElement(_styles.StyledTextAreaInput, _extends({}, other, {
          height: this.state.height,
          innerRef: function innerRef(element) {
            _this2.input = element;
          },
          rows: this.props.rows,
          onChange: this.handleChange
        }))
      );
    }
  }]);

  return NitroTextArea;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.syncHeightWithShadow = function (newValue, event) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this3.props;

    var displayText = _this3.props.hintText && (newValue === '' || newValue === undefined || newValue === null) ? _this3.props.hintText : newValue;

    if (displayText !== undefined) {
      _this3.shadow.value = displayText;
    }

    var newHeight = _this3.shadow.scrollHeight;

    // Guarding for jsdom, where scrollHeight isn't present.
    // See https://github.com/tmpvar/jsdom/issues/1013
    if (newHeight === undefined) return;

    if (props.rowsMax >= props.rows) {
      newHeight = Math.min(props.rowsMax * ROW_HEIGHT, newHeight);
    }

    newHeight = Math.max(newHeight, ROW_HEIGHT);

    if (_this3.state.height !== newHeight) {
      var input = _this3.input;
      var cursorPosition = input.selectionStart;
      _this3.setState({
        height: newHeight
      }, function () {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });

      if (typeof props.onHeightChange === 'function') {
        props.onHeightChange(event, newHeight);
      }
    }
  };

  this.handleResize = function (event) {
    _this3.syncHeightWithShadow(undefined, event);
  };

  this.handleChange = function (event) {
    if (typeof _this3.props.value === 'undefined') {
      _this3.syncHeightWithShadow(event.target.value);
    }

    if (_this3.props.onChange) {
      _this3.props.onChange(event);
    }
  };
};

NitroTextArea.propTypes = {
  defaultValue: _propTypes2.default.any,
  disabled: _propTypes2.default.bool,
  hintText: _propTypes2.default.node,
  onChange: _propTypes2.default.func,
  onHeightChange: _propTypes2.default.func,
  rows: _propTypes2.default.number,
  rowsMax: _propTypes2.default.number,
  value: _propTypes2.default.string
};

NitroTextArea.defaultProps = {
  rows: 1
};

exports.default = NitroTextArea;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-text-field/NitroTextArea.js
// module id = 3042
// module chunks = 4